import { TranslationsContext } from '@teliaee/telia-translate';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { PromotedManufacturers, TradeInCalculatorComponent } from '@teliaee/telia-common-components';
import { THeadingElement } from 'telia-front-react';
import config from '../Config';
import LanguageStore from '../stores/LanguageStore';
import ShoppingCartStore from '../stores/ShoppingCartStore';
import SsoStore from '../stores/SsoStore';
import TradeInSuccessContent from './TradeInSuccessContent';

export interface TradeInComponentProps {
  headingElement?: THeadingElement;
  languageStore?: LanguageStore;
  ssoStore?: SsoStore;
  shoppingCartStore?: ShoppingCartStore;
  promotedManufacturers?: PromotedManufacturers;
  disableTranslationsStatistics?: boolean;
  isTestEnvironment?: boolean;
}

@observer
class TradeInComponent extends React.Component<TradeInComponentProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;

  public render() {
    const translate = this.context.translate;
    return (
      <TradeInCalculatorComponent
        headingElement={this.props.headingElement}
        tier={config.componentTier}
        language={this.props.languageStore.currentLanguage}
        app={'public'}
        isLoggedIn={this.props.ssoStore.loggedIn}
        ensureLogin={this.props.ssoStore.ensureLogin}
        onSuccess={this.props.shoppingCartStore.updateCartItemsNumber}
        tradeInSuccessContent={(props: any) => <TradeInSuccessContent {...props} translate={translate} />}
        promotedManufacturers={this.props.promotedManufacturers}
        disableTranslationsStatistics={this.props.disableTranslationsStatistics}
        isTestEnvironment={this.props.isTestEnvironment}
      />
    );
  }
}

export default inject('languageStore', 'ssoStore', 'shoppingCartStore')(TradeInComponent);
